<template>
    <div class="mt-2">
        <div v-if="recipes.length" class="flex flex-col gap-2">
            <Link
                v-for="recipe in recipes.slice(0, count)"
                :key="recipe.id"
                :href="`/recipes/${recipe.slug}`"
                class="home-recipe-row flex items-center gap-3 rounded border border-slate-700/40 bg-slate-900/30 overflow-hidden group"
            >
                <img
                    :ref="`img-${recipe.id}`"
                    class="w-14 h-14 object-cover flex-shrink-0 transition-transform duration-500 group-hover:scale-105"
                    :src="recipe.bg"
                    :alt="recipe.name"
                    @error="imageLoadError(recipe.id)"
                >
                <div class="min-w-0 flex-1 py-1 pr-2">
                    <h3 class="text-sm font-semibold text-slate-100 leading-tight truncate group-hover:text-yellow-200">
                        {{ recipe.name }}
                    </h3>
                    <p class="text-xs text-slate-400 leading-tight">
                        {{ formatDate(recipe.created_at, 'MMM D, YYYY') }}
                    </p>
                </div>
            </Link>
        </div>
        <div v-else class="w-full h-24 flex flex-wrap justify-center items-center text-center text-slate-400">
            No Recipes Yet.
        </div>
    </div>
</template>

<script>
    import { formatDate } from '@/utils/Utilities';
    import { Link } from '@inertiajs/vue3'
    import { gsap } from 'gsap/all'

    export default {
        name: 'HomeLatestRecipes',
        components: { Link },
        props: {
            recipes: {
                type: Array,
                default: () => [],
            },
            count: {
                type: Number,
                default: 5,
            },
        },
        mounted() {
            gsap.fromTo('.home-recipe-row',
                { y: 10, opacity: 0 },
                { y: 0, opacity: 1, stagger: .03, duration: .25 },
            )
        },
        methods: {
            formatDate,
            imageLoadError(id) {
                const im = this.$refs[`img-${id}`];
                if (im && im[0]) {
                    im[0].src = '/images/recipes/nopic.svg';
                }
            },
        },
    }
</script>

<style lang="postcss">
.home-recipe-row {
    opacity: 0;
}
</style>
